import { FC } from 'react'
import { useLocation } from 'react-router-dom'
import { ErrorPageView } from '@norstella/nxp-sso-web/components/views/ErrorPageView'
import { FormType } from '@norstella/nxp-sso-web/utils/Forms'
import { useBranding } from '../hooks/useBranding'

export const VerifyEmailSuccess: FC = () => {
  const urlParams = new URLSearchParams(useLocation().search)
  const [forms] = useBranding()

  const isVerificationFailed = urlParams.get('success') === 'false'
  const message = urlParams.get('message') ?? undefined
  const isLinkExpired = message === 'Access expired.'

  const { header, footer } = isVerificationFailed
    ? forms[FormType.verifyEmailError]
    : forms[FormType.verifyEmail]

  let title: string
  let description: string
  let text: string

  if (isLinkExpired) {
    title = 'Expired'
    text = 'Link Expired'
    description = 'This link is expired for security reasons.'
  } else if (isVerificationFailed) {
    title = 'Failed'
    text = 'Verification Failed'
    description = message ?? 'Your email address could not be verified.'
  } else {
    text = 'Your email address has been verified successfully'
    title = 'You\'re All Set!'
    description = 'You can now go back to the application and sign in to continue.'
  }

  return <ErrorPageView
    error={text}
    errorDescription={description}
    header={{ ...header, text: title }}
    footer={footer}
  />
}
